import { type TLimitedAudioLicense } from './audioLicense'

export type TLicenseInfo = {
    title: string
    description: string
    link?: string
}

// Ported as-is from audio-web `modules/audio/model/license` (content data, not UI chrome). The
// container maps the audio's license to this entry; a `none` license renders no card.
export const LICENSE_INFO: Record<TLimitedAudioLicense, TLicenseInfo> = {
    arr: {
        title: 'All Rights Reserved',
        description:
            'You retain all rights provided by copyright law. As such, another person cannot reproduce, distribute and/or adapt any part of the work without your permission.',
    },
    'cc-0': {
        title: 'Creative Commons 0',
        description:
            'Others can copy, modify, distribute, and perform the audio, even for commercial purposes, all without needing to ask permission from the author.',
        link: 'https://creativecommons.org/publicdomain/zero/1.0/',
    },
    'cc-by': {
        title: 'Attribution 4.0',
        description:
            'Others are free to share (to copy, distribute, and transmit) and to remix the audio as long as they credit the author.',
        link: 'https://creativecommons.org/licenses/by/4.0/',
    },
    'cc-by-nc': {
        title: 'Attribution NonCommercial 4.0',
        description:
            'Others are free to share (to copy, distribute, and transmit) and to remix the audio as long as they credit the author and do not use the audio for commercial purposes.',
        link: 'https://creativecommons.org/licenses/by-nc/4.0/',
    },
    'cc-by-sa': {
        title: 'Attribution-ShareAlike 4.0',
        description:
            'You must give appropriate credit, provide a link to the license, and indicate if changes were made.',
        link: 'https://creativecommons.org/licenses/by-sa/4.0/deed.en',
    },
}
